<template>
  <div class="personal-center-page">
    <LoginButton />

    <div class="container">
      <!-- 左侧导航 -->
      <div class="left-nav-container">
        <div class="nav-image">
          <img src="./assets/img/header.png" alt="header" />
        </div>
        <aside class="left-nav">
          <div class="nav-header">个人中心</div>
        <ul class="nav-menu">
          <router-link v-for="item in navs" :key="item.path" :to="'/store/personal/' + item.path" tag="li"
            active-class="active">
            <span v-if="item.path === 'resume'" class="nav-icon" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M19.1578 1.50244H4.83984C4.05937 1.50244 3.42656 2.12588 3.41016 2.904H3.50859C3.47578 2.904 3.44531 2.90635 3.41016 2.90869V21.0657C3.41016 21.8556 4.05234 22.4978 4.84219 22.4978H19.1578C19.9453 22.4978 20.5875 21.8556 20.5875 21.0657V2.90635C20.5711 2.12588 19.9359 1.50244 19.1578 1.50244ZM12.4219 17.0157C12.4219 17.4282 12.0844 17.7657 11.6719 17.7657H8.25C7.8375 17.7657 7.5 17.4282 7.5 17.0157C7.5 16.6032 7.8375 16.2657 8.25 16.2657H11.6719C12.0844 16.2657 12.4219 16.6032 12.4219 17.0157ZM14.5312 12.0001C14.5312 12.4126 14.1937 12.7501 13.7812 12.7501H8.25C7.8375 12.7501 7.5 12.4126 7.5 12.0001C7.5 11.5876 7.8375 11.2501 8.25 11.2501H13.7812C14.1937 11.2501 14.5312 11.5876 14.5312 12.0001ZM16.5 6.98447C16.5 7.39697 16.1625 7.73447 15.75 7.73447H8.25C7.8375 7.73447 7.5 7.39697 7.5 6.98447C7.5 6.57197 7.8375 6.23447 8.25 6.23447H15.75C16.1625 6.23447 16.5 6.57197 16.5 6.98447Z" fill="url(#paint0_linear_4856_13092)"/>
                <defs>
                  <linearGradient id="paint0_linear_4856_13092" x1="3.41016" y1="12.0001" x2="20.5875" y2="12.0001" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#62AFFF"/>
                    <stop offset="1" stop-color="#9C41FF"/>
                  </linearGradient>
                </defs>
              </svg>
            </span>
            <i v-else :class="item.icon"></i>
            <span>{{ item.title }}</span>
          </router-link>
        </ul>
        <div class="logout-btn" @click="handleLogout">
          <i class="el-icon-switch-button"></i> 退出登录
        </div>
        </aside>
      </div>

      <!-- 右侧内容 -->
      <main class="right-content">
        <!-- 顶部用户信息 -->

        <avatar-cropper-dialog :visible.sync="showCropper" :original-image="initialImage" @confirm="handleCropConfirm"
          @cancel="handleCropCancel"></avatar-cropper-dialog>
        <!-- 白色卡片 -->
        <div class="basic-info-container">
          <div class="profile-header">
            <el-avatar class="big-avatar" :src="userAvatar" @click.native="showCropper = true"></el-avatar>
            <div class="profile-info">
              <div class="name-vip">
                <span class="username">HI {{ username }}!</span>
                <div class="vip-line">
                  <span class="vip-tag">UID：{{ userId }}</span>
                  <el-tag type="primary" class="diamond-tag">
                    <img src="./assets/img/diamond.png" class="icon-left" /> 钻石会员
                  </el-tag>
                </div>
              </div>
            </div>
          </div>

          <!-- 二级路由出口 -->
          <div class="content">
            <router-view :userInfo="userInfo" />
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import AvatarCropperDialog from './components/AvatarCropperDialog.vue';
import { getUserInfo, setInfo } from '@/api/user';
import { updateUser } from '@/api/user';
import { uploadImg } from '@/api/upload'

export default {
  components: {
    AvatarCropperDialog
  },
  data() {
    return {
      showCropper: false,
      initialImage: 'https://picsum.photos/id/64/200/200', // 默认头像，运行时会尝试从 localStorage 覆盖
      avatarDialogVisible: false,
      userInfo: {
        name: '',
        avatar: '',
        id: '',
        age: '',
        gender: '',
        phone: '',
        email: '',
        education: '',
        school: '',
        major: ''
      },
      navs: [
        { title: '基本信息', path: 'basic', icon: 'el-icon-user' },
        { title: '简历管理', path: 'resume', icon: 'el-icon-document' },
        { title: '账号安全', path: 'security', icon: 'el-icon-lock' },
        { title: '通用设置', path: 'general', icon: 'el-icon-setting' },
        { title: '隐私设置', path: 'privacy', icon: 'el-icon-view' }
      ],
      avatar: 'https://picsum.photos/id/64/200/200'
    }
  },
  computed: {
    // 从store获取用户名
    username() {
      return this.$store.state.user.name || this.userInfo.name || '用户';
    },
    // 从store获取头像
    userAvatar() {
      return  this.$store.state.user.avatar || this.userInfo.avatar || this.initialImage ;
    },
    // 获取用户ID
    userId() {
      return this.userInfo.id || '';
    }
  },
  async created() {
    await this.loadUserInfo();
    try {
      const storedAvatar = localStorage.getItem('userAvatar');
      if (storedAvatar) {
        this.initialImage = storedAvatar;
      }
    } catch (e) {
      // 忽略本地存储异常，使用默认头像
    }
  },
  methods: {
    // 加载用户信息
    async loadUserInfo() {
      try {
        const response = await getUserInfo();
        console.log("获取用户信息响应:", response);

        if (response.data.code == 1) {
          const userData = response.data.data;
          console.log("用户信息:", userData);

          // 确保 userData 存在，如果不存在则使用空对象
          const safeUserData = userData || {};

          // 填充完整的用户信息
          this.userInfo = {
            name: safeUserData.real_name || safeUserData.nickname || '',
            avatar: safeUserData.avatar || '',
            id: safeUserData.id || '',
            age: safeUserData.age || '',
            gender: safeUserData.sex || '',
            phone: safeUserData.mobile || safeUserData.phone || '',
            email: safeUserData.email || '',
            education: safeUserData.education || '',
            school: safeUserData.school || '',
            major: safeUserData.major || ''
          };
          
          // 更新store中的用户信息
          if (this.userInfo.name) {
            this.$store.commit('user/SET_NAME', this.userInfo.name);
          }
          if (this.userInfo.avatar) {
            this.$store.commit('user/SET_AVATAR', this.userInfo.avatar);
            this.initialImage = this.userInfo.avatar;
          }
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        // 尝试从localStorage获取用户信息
        try {
          const storedUserInfo = localStorage.getItem('userInfo');
          if (storedUserInfo) {
            const userData = JSON.parse(storedUserInfo);
            this.userInfo = {
              name: userData.name || userData.nickname || '',
              avatar: userData.avatar || '',
              id: userData.id || '',
              age: userData.age || '',
              gender: userData.sex || '',
              phone: userData.mobile || userData.phone || '',
              email: userData.email || '',
              education: userData.education || '',
              school: userData.school || '',
              major: userData.major || ''
            };
          }
        } catch (e) {
          console.error('从localStorage获取用户信息失败:', e);
        }
      }
    },
    
    async handleCropConfirm(imageData) {
      try {
        // 1) 若是 base64，使用 fetch 转 Blob，再构建 File
        let file = null
        if (/^data:image\//.test(imageData)) {
          const resp = await fetch(imageData)
          const blob = await resp.blob()
          file = new File([blob], 'avatar.png', { type: blob.type || 'image/png' })
        }
        // 2) 上传图片，获取线上链接
        let onlineUrl = ''
        if (file) {
          const res = await uploadImg('avatar', file)
          onlineUrl = res?.data?.data?.url || ''
        } else {
          onlineUrl = imageData
        }
        if (!onlineUrl) {
          this.$message.error('上传头像失败，请重试')
          return
        }
        // 3) 调用更新用户头像接口
        const resUpdate = await updateUser({
          avatar: onlineUrl,
          nickname: this.userInfo.name
        })
        if (resUpdate && resUpdate.data && resUpdate.data.code === 1) {
          this.initialImage = onlineUrl
          try { localStorage.setItem('userAvatar', onlineUrl) } catch (e) {}
          // // 重新拉取用户信息，刷新页面状态
          await this.loadUserInfo()
          this.$message.success('头像更新成功')
        } else {
          this.$message.error(resUpdate?.data?.msg || '头像更新失败')
        }
      } catch (e) {
        console.error(e)
        this.$message.error('头像保存失败，请重试')
      } finally {
        this.showCropper = false
      }
    },
    handleCropCancel() {
      console.log('取消裁剪');
    },

    handleAvatarSaved(newAvatarUrl) {
      this.initialImage = newAvatarUrl;
      try {
        localStorage.setItem('userAvatar', newAvatarUrl);
      } catch (e) {}
      this.$message.success('头像更换成功');
    },
    // 更新用户信息（供子组件调用）
    async updateUserInfo(updatedInfo) {
      try {
        const response = await setInfo(updatedInfo);
        if (response && response.data.code === 1) {
          // 更新本地用户信息
          this.userInfo = { ...this.userInfo, ...updatedInfo };
          this.$message.success('个人信息更新成功');
          return true;
        } else {
          this.$message.error(
            response?.data?.msg || "个人信息更新失败，请重试"
          );
          return false;
        }
      } catch (error) {
        console.error("更新个人信息失败:", error);
        this.$message.error("网络错误，请检查网络连接后重试");
        return false;
      }
    },

    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('user/logout').then(() => {
          this.$message.success('已成功退出登录');
          this.$router.push('/store/entry');
        }).catch(error => {
          console.error('退出登录失败:', error);
          this.$message.error('退出登录失败，请重试');
        });
      })
    }
  }
}
</script>

<style scoped>
.personal-center-page {
  background: url(./assets/img/image.png) no-repeat center/cover;
  padding: 40px;
  height: 100vh;
  box-sizing: border-box;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  display: flex;
  gap: 40px;
  /* width: 1080px; */
  height: 720px;
  max-width: none;
}

.left-nav-container {
  position: relative;
}

.nav-image {
  position: absolute;
  top: -80px;
  left: 0;
  width: 220px;
  z-index: 10;
  text-align: center;
}

.nav-image img {
/*   width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.1); */
}

.left-nav {
  position: relative;
  width: 220px;
  height: 100%;
  border-radius: 16px;
  background: linear-gradient(321deg, rgba(255, 255, 255, 0.00) 2.06%, rgba(255, 255, 255, 0.20) 99.08%);
  box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.05), 4px 4px 20px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(15px);
  display: flex;
  flex-direction: column;
  margin-top: 0;
}

.nav-header {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  padding: 24px 20px 20px 20px;
  color: #656587;
}

.nav-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-menu li {
  padding: 14px 16px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.3s;
  color: #656587;
  text-align: left;
  font-size: 16px;
  font-family: "Source Han Sans CN VF";
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  border-radius: 8px;
}

.nav-menu li i {
  font-size: 18px;
  width: 18px;
  text-align: center;
}

.nav-menu .nav-icon svg {
  width: 18px;
  height: 18px;
  display: block;
}

.nav-menu li:hover,
.nav-menu li.active {
  position: relative;
  /* 关键：给伪元素做定位参照 */
  background: linear-gradient(180deg, rgba(177, 110, 249, 0.12) 0%, rgba(126, 180, 235, 0.12) 100%);
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
font-family: "Source Han Sans CN VF";
font-size: 16px;
font-style: normal;
line-height: 100%; /* 20px */
  /* 原来的 border-left 去掉 */
}

.nav-menu li.active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 10px;
  background: linear-gradient(1800deg, #7EB4EB 0%, #B16EF9 100%);
  pointer-events: none;
}

.logout-btn {
  padding: 14px 20px;
  margin-top: auto;
  text-align: center;
  border-top: 1px solid #f0f2f5;
  color: #f53f3f;
  cursor: pointer;
  font-size: 14px;
}

.logout-btn:hover {
  background: #fff5f5;
}

.right-content {
  width: 1080px;
  position: relative;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}


.user-avatar {
  width: 36px;
  height: 36px;
  margin-right: 8px;
}


.basic-info-container {
  position: relative;
  border-radius: 16px;
  background: var(--Linear, linear-gradient(321deg, rgba(255, 255, 255, 0.40) 2.06%, rgba(255, 255, 255, 0.72) 42.17%, rgba(255, 255, 255, 0.80) 99.08%));
  box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.05), 4px 4px 20px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(15px);
  padding: 30px 40px;
  margin-top: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}


.profile-header {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #0000002E;
}

.big-avatar {
  width: 64px;
  height: 64px;
  margin-right: 20px;
  border: 2px solid #f0f2f5;
}

.vip-line {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.vip-tag {
  font-size: 14px;
  color: #86909c;
  margin-right: 10px;
}

.diamond-tag {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  border-radius: 12px;
  font-family: Afacad;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  color: #fff;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  line-height: 22px;
  padding: 0 8px;
}

.name-vip {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.username {
  font-size: 16px;
  font-weight: bold;
  color: #656587;
}

.vip-tag {
  font-size: 14px;
  color: #86909c;
  margin-right: 10px;

}

.content {
  margin-top: 20px;
  flex: 1;
  min-height: 0;
  overflow: auto;

}

.icon-left {
  width: 14px;
  height: 14px;
  margin-right: 4px;
  vertical-align: middle;
}
</style>